<template>
  <div class="question-detail-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="问答详情" :showBack="true"></my-header>
    <div class="question-subject">{{question.subject}}</div>
    <div class="user-info border-bottom-style">
      <div class="user-info-left">
        <img v-if="question.avatarUrl" class="user-avatar-url" :src="question.avatarUrl">
        <img v-else="" class="user-avatar-url" src="../../assets/icon/icon-defualt-avatar.png">
        <div class="user-nickName">{{question.userName}}</div>
      </div>
      <div class="user-info-right">
        <div class="question-answerCount">回答&nbsp;&nbsp;{{question.answerCount || 0}}</div>
        <div>{{question.createTime | prettifyTime}}</div>
      </div>
    </div>
    <div class="qa-content">{{question.content}}</div>
    <div class="question-image-list-part" v-if="previewImageList.length>0">
       <img v-for="image in previewImageList" :src="image" @click = "previewImg(image,previewImageList)">
    </div>
    <div class="reply-title">
      评论
    </div>
    <div class="black-page" v-if="answerList.length==0">
      <img src="../../assets/icon-no-img.png">
      <div class="tip">还没有评论  快来抢沙发吧~</div>
    </div>
    <div class="answer-part" >
      <div class="user-info" v-if="answerList.length>0" v-for="answer in answerList">
        <img v-if="answer.avatarUrl" class="answer-part-avatar" :src="answer.avatarUrl">
        <img v-else="" class="answer-part-avatar" src="../../assets/icon/icon-defualt-avatar.png">
        <div style="width: 6rem">
          <div class="user-name">{{answer.userName}}
            <img class="icon-reply-btn" @click="commentUser(answer.id,answer.userId,answer.userName,'')" src="../../assets/icon/icon-reply-btn.png">
          </div>
          <div class="create-time">{{answer.createTime | time}}</div>
          <div class="answer-content">{{answer.content}}</div>
          <div v-if="answer.replyList.length > 0" class="reply-part">
            <div v-for="reply in answer.replyList" @click="commentUser(answer.id,reply.userId,reply.userName,reply.id)">{{reply.userName}}: {{reply.content}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="comment-footer-part">
      <div v-if="isComment" class="comment-container">
        <textarea v-focus class="qa-detail-text" v-model="content"  rows="3" :placeholder="placeholderText"></textarea>
        <div class="reply-ptn" @click="saveComment">
          <img src="../../assets/icon-reply-send-btn.png"/>
        </div>
      </div>
      <div v-if="!isComment && !isReply" class="footer-part-bottom">
        <div class="before-search-part" @click="beforeComment">评论</div>
      </div>
      <div v-if="isReply" class="comment-container">
        <textarea v-focus class="qa-detail-text" v-model="content"  rows="3" :placeholder="placeholderText"></textarea>
        <div class="reply-ptn" @click="saveReply">
          <img src="../../assets/icon-reply-send-btn.png"/>
        </div>
      </div>
    </div>
    <div v-if="isComment" class="general-box-bg" style="z-index: 100" @click="cancelComment"></div>
    <div v-if="isReply" class="general-box-bg"  style="z-index: 100" @click="cancelReply"></div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import questionService from '../../service/qa/QuestionService'
  import answerService from '../../service/qa/AnswerService'
  import {imgUrl} from "../../config";
  import session from '../../utils/Session'
  import envUtils from '../../utils/EnvUtils'

  export default {
    name: 'QaDetail',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imgUrl: imgUrl,
        questionId:'',
        answerId:'',
        content:'',
        question:{quImages:[]},
        answerList:[],
        isReply:false,
        isComment:false,
        showCancel:true,
        isWechatBrowser:this.$verfyBrowserType(),
        showImage:'',
        showBig:false,
        previewImageList:[],
        placeholderText:'评论',
        replyedUserId:'',
        replyId:'',
        showReplay:false,
      }
    },
    created(){
      this.questionId = this.$route.query.questionId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getQuestionDetail();
      this.getAnswerList();
    },
    directives: {
      focus: {
        // 指令的定义
        inserted: function (el) {
          el.focus()
        }
      }
    },
    watch:{
//      content(value){
//        if (value) {
//          this.showCancel = false;
//        } else {
//          this.showCancel = true;
//        }
//      }
    },
    methods: {
      async getQuestionDetail(){
        let {code,msg,data} = await questionService.detail(this.questionId);
        if(code == '0'){
          this.question = data;
          //问题没有录入内容取主题
          if(!this.question.content){
            this.question.content = data.subject;
          }
          if(!this.question.userName){
            this.question.userName = this.question.userPhone
          }
          this.previewImageList = [];
          if(this.question.images){
            let showImageArray = this.question.images.split(',');
            for (let image of showImageArray){
              let previewImage = this.imgUrl + image;
              this.previewImageList.push(previewImage)
            }
          }else {
            this.question.quImages = [];
          }
        }else {
          Toast(msg);
        }
      },
      closeReplayList(){
        this.showReplay = false;
      },
      showReplayList(){
        this.showReplay = true;
      },
      async getAnswerList(){
        let {code,msg,data} = await answerService.list(this.questionId);
        if(code == '0'){
          this.answerList = data;
          console.info(this.answerList)
          for (let answer of this.answerList)  {
            if(!answer.userName){
              answer.userName = answer.avatarPhone
            }
          }
        }else {
          Toast(msg);
        }
      },
      async beforeComment(){
        const isLogin = await session.isLogin();
        if(isLogin){
          this.isComment = true;
          this.placeholderText = '@' + this.question.userName;
        }else {
          session.userType('1');
          let backUrl = window.location.href.split('#')[1];
          if (envUtils.inLight()) {
            wx.miniProgram.navigateTo({url: `/pages/register/register?h5Url=${encodeURIComponent(backUrl)}`});
          } else {
            session.backUrl(backUrl)
            this.$router.push({name:'BindPhone'});
          }
        }
      },
      cancelComment(){
        this.isComment = false;
        this.content = '';
      },
      async saveComment(){
        if(!this.content){
          Toast('请输入评论内容');
          return false;
        }
        let answer = {questionId:this.questionId,content:this.content,type:'1'};
        let {code,msg,data} = await answerService.save(answer);
        if(code == '0'){
          Toast('评论成功!');
          this.answerList = [];
          this.getAnswerList();
          this.content = '';
          this.isComment = false;
        }else {
          Toast('评论失败!');
        }
      },
      async commentUser(answerId,userId,userName,replyId){
        const isLogin = await session.isLogin();
        if(isLogin){
          this.answerId = answerId;
          this.replyedUserId = userId;
          this.replyId = replyId;
          this.isReply = true;
          this.placeholderText = '回复给'+userName;
        }else {
          session.userType('1');
          let backUrl = window.location.href.split('#')[1];
          if (envUtils.inLight()) {
            wx.miniProgram.navigateTo({url: `/pages/register/register?h5Url=${encodeURIComponent(backUrl)}`});
          } else {
            session.backUrl(backUrl)
            this.$router.push({name:'BindPhone'});
          }
        }
      },
      cancelReply(){
        this.isReply = false;
        this.content = '';
      },
      async saveReply(){
        if(!this.content){
          Toast('请输入回复内容');
          return false;
        }
        let answer = {questionId:this.questionId,replyUserId:this.replyedUserId,answerId:this.answerId,content:this.content,type:'2',replyId:this.replyId};
        let {code,msg,data} = await answerService.save(answer);
        if(code == '0'){
          Toast('回复成功!');
          this.answerList = [];
          this.getAnswerList();
            this.isReply = false;
            this.answerId = '';
            this.content = '';
        }else {
          Toast('回复失败!');
        }
      },
      showBigImg(contract){
        this.showImage = this.imgUrl + contract;
        this.showBig = true;
      },
      previewImg(currentImage,previewImageList){
        wx.previewImage({
          current: currentImage, // 当前显示图片的http链接
          urls: previewImageList // 需要预览的图片http链接列表

        });
      },
      toAnswerDetail(answerId){
        this.$router.push({name: 'AnswerDetail',query:{answerId,questionId:this.questionId}});
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .question-detail-page {
    background: white;
    padding-top: 0.3rem;
    padding-bottom: 4.6rem;
    font-size: 0.28rem;
    .question-subject{
      width: 6.9rem;
      margin: 0 auto;
      font-size: 0.36rem;
      color: #191818;
      font-weight: bold;
    }
    .user-info{
      display: flex;
      justify-content: space-between;
      width: 6.9rem;
      margin: 0.29rem auto 0;
      padding-bottom: 0.2rem;
      font-size: 0.24rem;
      color: #cecbca;
      .user-info-left{
        display: flex;
      }
      .user-info-right{
        display: flex;
        padding-top: 0.1rem;
        padding-bottom: 0.2rem;
        .question-answerCount{
          margin-right: 0.25rem;
        }
      }
      .user-avatar-url{
        flex-shrink: 0;
        width: 0.47rem;
        height: 0.47rem;
        border-radius: 0.92rem;
        margin-right: 0.2rem;
      }
      .user-nickName{
        padding-top: 0.1rem;
        padding-bottom: 0.2rem;
      }
      .reply-part{
        padding-left: 0.09rem;
        margin-top: 0.2rem;
        border-left: solid 0.06rem #cecbca;
        font-size: 0.28rem;
        color: #cecbca;
      }
      .create-time{
        font-size: 0.24rem;
        color: #7f7d7c;
      }
    }
    .reply-title{
      margin-top: 0.2rem;
      margin-left: 0.3rem;
      font-size: 0.36rem;
      font-weight: bold;
    }
    .black-page{
      height: 4rem;
      img{
        margin-top: 0.43rem;
      }
    }
    .question-image-list-part{
      width: 6.9rem;
      margin: 0.3rem auto;
      img{
        display: block;
        max-width: 100%;
        margin-bottom: 0.3rem;
        border-radius: 8px;
      }
    }
    .qa-content{
      padding:0.25rem 0.3rem 0;
      line-height: 0.54rem;
      font-size: 0.32rem;
      color: #7f7d7c;
    }
    .answer-part{
      .user-info{
        .user-name{
          font-size: 0.28rem;
          color: #191818;
          position: relative;
          .icon-reply-btn{
            width: 0.39rem;
            height: 0.34rem;
            position: absolute;
            right: 0.1rem;
            top: 0.1rem
          }
        }
        .answer-content{
          padding-top: 0.1rem;
          font-size: 0.32rem;
          color: #191818;
          width: 5.8rem;
        }
      }
      .answer-part-avatar{
        width: 0.88rem;
        height: 0.88rem;
        border-radius: 0.44rem;
        margin-right: 0.2rem;
      }
      .answer-part-title{
        padding:0 0.3rem 0 0.3rem;
        color: #1b1e29;
        font-size: 0.36rem;
      }
    }
    .before-search-part{
      width: 6.7rem;
      height: 0.7rem;
      line-height: 0.7rem;
      margin: 0rem 0.3rem;
      padding-left: 0.2rem;
      font-size: 0.32rem;
      color: #cecbca;
      background-color: #f7f6f5;
      border-radius: 8px;
    }
    .comment-footer-part{
      position: fixed;
      bottom: 0rem;
      display: flex;
      width: 100%;
      background: white;
      z-index: 1002
    }
    .footer-part-bottom{
      margin-top: 0.3rem;
      margin-bottom: 0.2rem;
    }
    .comment-container{
      display: flex;
      align-items: center;
      margin: 0.2rem 0 0.2rem 0.2rem;
      z-index: 1002;
      img{
        width: 0.44rem;
        height: 0.44rem;
      }
    }
    .qa-detail-text{
      background: #f7f6f5;
      width: 6.1rem;
      padding: 0.1rem;
      color: #191818;
      font-size: 0.32rem;
      resize:none
    }
    .reply-ptn{
      padding: 0.25rem;
    }
  }
</style>
